import { render, staticRenderFns } from "./FRPAdditionalInformation.vue?vue&type=template&id=b45e8bde&scoped=true&"
import script from "./FRPAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./FRPAdditionalInformation.vue?vue&type=script&lang=js&"
import style0 from "./FRPAdditionalInformation.vue?vue&type=style&index=0&id=b45e8bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45e8bde",
  null
  
)

export default component.exports